import type { AppDatabase } from '../../db/database';

/**
 * Drop the translations of records that are being deleted. A translation of
 * nothing would never be shown, but it would still sync to every device and
 * count in the usage view.
 */
export async function removeOwnerTranslations(
    database: AppDatabase,
    ownerIds: readonly string[]
): Promise<void> {
    if (ownerIds.length === 0) {
        return;
    }
    await database.translations
        .find({ selector: { ownerId: { $in: [...ownerIds] } } })
        .remove();
}
